<template>
  <div class="layout" >
   <div class="layout__body">
      <main class="layout__content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="less" scoped>
</style>